import { render } from "./WhyDigitalPrint.vue?vue&type=template&id=210d65bf&scoped=true"
import script from "./WhyDigitalPrint.vue?vue&type=script&lang=js"
export * from "./WhyDigitalPrint.vue?vue&type=script&lang=js"

import "./WhyDigitalPrint.vue?vue&type=style&index=0&id=210d65bf&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210d65bf"]])

export default __exports__